import { atomWithReset } from "jotai/utils";

// Utility to deeply flatten countComponentDTOList inside designComponentsList

export function flattenDesignCountComponent(designComponentsList) {
  if (!Array.isArray(designComponentsList)) return [];
  return designComponentsList.map(design => ({
    ...design,
    designVersionComponents: Array.isArray(design.designVersionComponents)
      ? design.designVersionComponents.map(version => ({
          ...version,
          componentDTOList: flattenCountComponentDTOList(version.countComponentDTOList)
        }))
      : []
  }));
}

// Utility function to flatten countComponentDTOList to match componentDTOList structure,
// and only include the first unique component per type.
// Accepts either a countComponentDTOList or a designComponentsList (array of objects with countComponentDTOList)
export function flattenCountComponentDTOList(input) {
  // If input is an array of designComponentsList objects, apply flattening to each
  if (Array.isArray(input) && input.length > 0 && input[0]?.countComponentDTOList) {
    return input.map(designObj => flattenCountComponentDTOList(designObj.countComponentDTOList));
  }
  // Otherwise, treat as countComponentDTOList (original logic)
  const seen = new Set();
  const result = [];
  input.forEach((item) => {
    if (item.data && item.data.length > 0) {
      for (const comp of item.data) {
        const key = `${comp.componentType}-${comp.componentId}`;
        if (!seen.has(key)) {
          seen.add(key);
          result.push(comp);
          break;
        }
      }
    }
  });
  return result;
}

// Example usage when setting the atom:
// set(projectDetailsAtom, prev => ({
//   ...prev,
//   countComponentDTOList: flattenCountComponentDTOList(newCountComponentDTOList)
// }));

export const projectDetailsAtom = atomWithReset({
  userId: "",
  projectDTO: {
    projectId: null,
    projectName: "",
    projectType: "",
  },
  componentDTOList: [],
  countComponentDTOList: [], // <-- set this using flattenCountComponentDTOList
  designWithVersionsDTOList: [],
  designComponentsList: [],
  locationDTO: {
    projectId: null,
    locationId: null,
    address: "",
    city: "",
    zipCode: "",
  },
});
